import { createElement, isValidElement } from 'react';
import type { ComponentType, ReactNode } from 'react';
import { cn } from '../../lib/utils';

type IconLike = ReactNode | ComponentType<{ size?: number | string; className?: string }>;

interface EmptyStateProps {
  icon?: IconLike;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Prázdný stav — pro prázdné tabulky, listy nebo výsledky vyhledávání.
 *
 * `icon` přijme JSX (`icon={<Server size={24} />}`) nebo přímo komponent
 * (`icon={Server}`); v druhém případě se instancuje se `size={24}`.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  const rendered: ReactNode = (() => {
    if (!icon) return null;
    if (typeof icon === 'function') return createElement(icon, { size: 24 });
    if (isValidElement(icon)) return icon;
    return null;
  })();

  return (
    <div className={cn('flex flex-col items-center justify-center py-12 text-center', className)}>
      {rendered && <div className='text-gray-600 mb-3'>{rendered}</div>}
      <p className='text-sm font-medium text-gray-400'>{title}</p>
      {description && <p className='text-xs text-gray-600 mt-1'>{description}</p>}
      {action && <div className='mt-4'>{action}</div>}
    </div>
  );
}
